import React, { useState, useEffect, useReducer } from 'react';
import axios from 'axios';
import { regions } from '../../data/regions';
import { priceToMargin } from '../../js/priceToMargin';
import { getProductAttributes } from '../../js/getProductAttributes';
import { checkboxToArr } from '../../js/utils/checkBoxToArr';
import { AmazonInventoryScreen } from '../../screens/AmazonInventoryScreen/AmazonInventoryScreen';
import loading from '../../img/loading.gif';

export function AmazonInventory(props) {
  const [amazonInventory, setAmazonInventory] = useState([]); //lists all inventory
  //const [selectedProductLines, setSelectedProductLines] = useState([]); //arr of selected ids
  //const [selectedProductObj, setSelectedProductObj] = useState([]); //arr of objects of selected ids
  const [selectedRegions, setSelectedRegions] = useState([]); //arr of selected regions
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    //load initial inventory
    getInventory();
  }, []);

  const getInventory = () => {
    axios
      .get(process.env.REACT_APP_HOST + 'getAmazonInventory')
      .then((res) => {
        const inventory = addNewFieldsToInventory(res.data);
        setAmazonInventory(inventory);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //adds presentational fields to inventory
  function addNewFieldsToInventory(inventory) {
    Object.values(inventory).forEach((product, value) => {
      product.blendedMinMargin = 0;
      //   product.blendedMinMargin =
      //     regions.reduce((acc, region) => {
      //       return acc + parseFloat(props.product[region].minTargetMargin);
      //     }, 0) / regions.length;
    });

    return inventory;
  }

  //make copy of existing inventory; update inventory with cached lines and save state
  function updateStateOnHideModal(cachedSelectedRows) {
    console.log(cachedSelectedRows)
    setSelectedRows([]);
    const copyAmazonInventory = [...amazonInventory];

    for (let i = 0; i < cachedSelectedRows.length; i++) {
      for (let j = 0; j < copyAmazonInventory.length; j++) {
        if (cachedSelectedRows[i].id === copyAmazonInventory[j].id) {
          copyAmazonInventory[j] = cachedSelectedRows[i];
        }
      }
    }

    // cachedSelectedRows.forEach((row, cachedIndex) => {
    //   copyAmazonInventory.forEach((product, productIndex) => {
    //     if (row.id === product.id) {
    //       console.log('up to date copy', copyAmazonInventory[productIndex], 'cached', cachedSelectedRows[cachedIndex]);
    //       copyAmazonInventory[productIndex] = cachedSelectedRows[cachedIndex];
    //     }
    //   });
    // });

    console.log({ copyAmazonInventory });
    //problem is here????
    setAmazonInventory(copyAmazonInventory);
    //doesnt fix the issue???
    if (cachedSelectedRows.length > 1) {
      setSelectedRows(cachedSelectedRows);
    }

    // console.log(selectedRows)

    // axios
    //   .get('http://localhost:8030/getSpecificAmazonProducts', {
    //     params: {
    //       selectedRows: selectedRows
    //     }
    //   })
    //   .then((res) => {
    //     setAmazonInventory(res.data);
    //     return res;
    // })
    // .then((res) => {
    //   //reapply filters using latest db data
    //   const arr = filteredInventory.map((product) => {
    //     return product.id;
    //   });
    //   const filtered = res.data.filter((product) => {
    //     return arr.indexOf(product.id) !== -1;
    //   });
    //   setFilteredInventory(filtered);
    //});
  }

  //set selected product lines to state when tick checkbox
  // function updateSelectedProductLines(e) {
  //   const { name, checked } = e.target;
  //   const arr = checkboxToArr([...selectedProductLines], name, checked);
  //   setSelectedProductLines(arr); //set product ids arr to state
  //   //const objArr = createProductObj(arr);
  //   //setSelectedRows(objArr); //sets arr of product object ids to state which is used in child components
  // }

  // // function createProductObj(arr) {
  // //   const objArr = [];

  // //   arr.forEach((selectedProductId) => {
  // //     Object.values(filteredInventory).forEach((product) => {
  // //       if (product.id === selectedProductId) {
  // //         objArr.push(product);
  // //       }
  // //     });
  // //   });
  // //   return objArr;
  // // }

  //updates base product in selectedRow state (not regional prices, regional breakevens etc)
  function updateBaseProductAttribute(e, index, originalProductData) {
    let { name, value } = e.target;
    console.log(value)
    if (name === 'lockBaseAttributes') {
      value = value.toLowerCase() === 'true' ? false : true;
    }
    const copySelectedProductObj = [...selectedRows];
    copySelectedProductObj[index][name] = value;
    setSelectedRows(copySelectedProductObj);
  }
  //holds selected regions in state
  function updateRegionArr(e) {
    const { name, checked } = e.target;
    setSelectedRegions(checkboxToArr([...selectedRegions], name, checked));
  }

  //updates regional prices etc
  async function updateRegionalProductAttribute(e, region, index, singleValue) {
    let { name, value } = e.target;
    const copySelectedProductObj = [...selectedRows];
    console.log(name)

    if (name === 'lockButton' || name === 'unlockButton') {
      if (singleValue === 'empty') {
        copySelectedProductObj[index][region].lockRegionPrices = true;
      } else if (singleValue === 'lockRegionPrices') {
        copySelectedProductObj[index][region].lockRegionPrices = false;
      }
    } else {
      copySelectedProductObj[index][region][name] = value;
      const selectedProductObjWithUpdatedAttributes =
        await updateRegionalProductAttributesAsResultOfOtherAttributeUpdating(
          name,
          copySelectedProductObj,
          region,
          index,
        );
      return setSelectedRows(selectedProductObjWithUpdatedAttributes);
    }
    return setSelectedRows(copySelectedProductObj);
  }

  //change another input box based on input data. Calcs done server side as includes shipping data etc
  async function updateRegionalProductAttributesAsResultOfOtherAttributeUpdating(name, productObj, region, index) {
    switch (name) {
      case 'minTargetMargin':
        productObj[index][region].minPrice = await getProductAttributes(
          productObj[index],
          region,
          productObj[index][region][name],
          'minPrice',
        );
        return productObj;
      case 'maxTargetMargin':
        productObj[index][region].maxPrice = await getProductAttributes(
          productObj[index],
          region,
          productObj[index][region][name],
          'maxPrice',
        );
        return productObj;
      case 'minPrice':
        productObj[index][region].minTargetMargin = await priceToMargin(
          productObj[index],
          region,
          productObj[index][region].minPrice,
        );
        return productObj;
      case 'maxPrice':
        productObj[index][region].maxTargetMargin = await priceToMargin(
          productObj[index],
          region,
          productObj[index][region].maxPrice,
        );
        return productObj;
    }

    let value = '';
    if (name === 'minTargetMargin') {
      value = 'minPrice';
    } else if (name === 'maxTargetMargin') {
      value = 'maxPrice';
    } else if (name === 'minPrice') {
    }
    return productObj;
  }

  //when base prices change, recalculate regional prices
  async function recalculateFromBasePrices() {
    console.log('t');
    const copySelectedProductObj = [...selectedRows];
    for (let i = 0; i < regions.length; i++) {
      await new Promise((resolve) => setTimeout(resolve, 10));
      copySelectedProductObj[0][regions[i]].minPrice = await getProductAttributes(
        copySelectedProductObj,
        regions[i],
        copySelectedProductObj[0][regions[i]].minTargetMargin,
        'minPrice',
      );
      await new Promise((resolve) => setTimeout(resolve, 10));
      copySelectedProductObj[0][regions[i]].maxPrice = await getProductAttributes(
        copySelectedProductObj,
        regions[i],
        copySelectedProductObj[0][regions[i]].maxTargetMargin,
        'maxPrice',
      );
      await new Promise((resolve) => setTimeout(resolve, 10));
      copySelectedProductObj[0][regions[i]].breakEvenPrice = await getProductAttributes(
        copySelectedProductObj,
        regions[i],
        0,
        'breakEvenPrice',
      );
    }
    setSelectedRows(copySelectedProductObj);
  }

  return (
    <>
      {!isLoading && (
        <AmazonInventoryScreen
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          amazonInventory={amazonInventory}
          // selectedProductLines={selectedProductLines}
          // setSelectedProductLines={setSelectedProductLines}
          // setSelectedProductObj={setSelectedProductObj}
          //selectedProductObj={selectedProductObj}
          //updateSelectedProductLines={updateSelectedProductLines}
          updateBaseProductAttribute={(e, index, tableData) => {
            updateBaseProductAttribute(e, index, tableData);
          }}
          recalculateFromBasePrices={recalculateFromBasePrices}
          updateRegionalProductAttribute={(e, region, index, value) => {
            updateRegionalProductAttribute(e, region, index, value);
          }}
          selectedRegions={selectedRegions}
          setSelectedRegions={setSelectedRegions}
          updateRegionArr={(e) => {
            updateRegionArr(e);
          }}
          updateStateOnHideModal={(e) => {
            updateStateOnHideModal(e);
          }}
        />
      )}
      {isLoading && (
        <div className='d-flex align-items-center justify-content-center' style={{ height: '90vh' }}>
          <img src={loading} />
        </div>
      )}
    </>
  );
}
